import{defineMessages}from'react-intl';

export default defineMessages({
button_confirm:{
id:'success_modal.button_confirm',
defaultMessage:'Exit'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL1N1Y2Nlc3NNb2RhbC9TdWNjZXNzTW9kYWwubWVzc2FnZXMuanMiXSwibmFtZXMiOlsiZGVmaW5lTWVzc2FnZXMiLCJidXR0b25fY29uZmlybSIsImlkIiwiZGVmYXVsdE1lc3NhZ2UiXSwibWFwcGluZ3MiOiJBQUFBLE9BQVNBLGNBQVQsS0FBK0IsWUFBL0I7O0FBRUEsY0FBZUEsZ0JBQWU7QUFDNUJDLGVBQWdCO0FBQ2RDLEdBQUksOEJBRFU7QUFFZEMsZUFBZ0IsTUFGRixDQURZLENBQWYsQ0FBZiIsImZpbGUiOiJTdWNjZXNzTW9kYWwubWVzc2FnZXMuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGRlZmluZU1lc3NhZ2VzIH0gZnJvbSAncmVhY3QtaW50bCc7XG5cbmV4cG9ydCBkZWZhdWx0IGRlZmluZU1lc3NhZ2VzKHtcbiAgYnV0dG9uX2NvbmZpcm06IHtcbiAgICBpZDogJ3N1Y2Nlc3NfbW9kYWwuYnV0dG9uX2NvbmZpcm0nLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnRXhpdCcsXG4gIH0sXG59KTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/components/SuccessModal/SuccessModal.messages.js
// module id = 2271
// module chunks = 0